export default "__VITE_ASSET__4b05714b__"